import { FormattedMessage } from "react-intl";
import ShipmentRoute from "../ShipmentDetails/components/ShipmentRoute/ShipmentRoute";
import SelectedOrders from "../ShipmentDetails/components/SelectedOrders/SelectedOrders";
import PackingList from "../ShipmentDetails/components/PackingList/PackingList";
import ShipmentSummary from "./components/ShipmentSummary";

interface IReviewProps {
  data: any;
  isLoading: boolean;
  state: any;
}

function Review({ isLoading, data, state }: IReviewProps) {
  return (
    <>
      <div className="display-sm font-semibold">
        <FormattedMessage id="general.review" defaultMessage="Review" />
      </div>
      <ShipmentRoute isLoading={isLoading} />
      <SelectedOrders data={data} isLoading={isLoading} isShipmentReview />
      <PackingList data={data} isLoading={isLoading} />
      <ShipmentSummary state={state} />
    </>
  );
}

export default Review;
